import React from 'react';

import { DeviceContext } from '@/components/DeviceProvider/DeviceProvider';
import { MOBILE_DEVICES } from '@/logic/main/constants';
import { DeviceType } from '@/logic/main/types';
import { isModalForMobileEnabled } from '@/logic/main/utils';
import { GameLaunchStrategies, LaunchStrategyEnum } from '@/types/gameTypes';
import get from '@/utils/lodash-alternatives';

import {
  DEFAULT_GAME_STRATEGY,
  LaunchStrategiesContext,
} from './LaunchStrategiesProvider';

export const getLaunchStrategyByParams = (
  integration: string,
  launchStrategies: GameLaunchStrategies | LaunchStrategyEnum[]
) => get(launchStrategies, integration, DEFAULT_GAME_STRATEGY);

export function GetGameLaunchStrategy(
  integration: string
): LaunchStrategyEnum | 'default' {
  const { launchStrategies } = React.useContext(LaunchStrategiesContext);
  return getLaunchStrategyByParams(integration, launchStrategies);
}

export function shouldUseModalForMobile(
  deviceType: DeviceType,
  launchStrategy: LaunchStrategyEnum
) {
  return (
    isModalForMobileEnabled &&
    MOBILE_DEVICES.includes(deviceType) &&
    launchStrategy === LaunchStrategyEnum.modalForMobile
  );
}

export function ShouldPreventDefaultForClick(integration?: string): boolean {
  const { launchStrategies, callbackMode } = React.useContext(
    LaunchStrategiesContext
  );
  const { deviceType, deviceNative: isNative } = React.useContext(
    DeviceContext
  );

  if (!integration) return callbackMode === 'event';

  const launchStrategy = getLaunchStrategyByParams(
    integration,
    launchStrategies
  );

  if (!isNative && launchStrategy === LaunchStrategyEnum.newWindow) return true;

  if (!isNative && shouldUseModalForMobile(deviceType, launchStrategy))
    return true;

  return callbackMode === 'event';
}
